// extracted by mini-css-extract-plugin
module.exports = {"SingleCard":"SingleCard_SingleCard__TKLci"};